export const versionInfo = {
  gitTag: 'v-1.2.1-97-g4b05607',
  tag: 'v-1.2.1',
  commitsAhead: '97',
  buildDate: 'Mon, 31 Aug 2026 11:11:32 GMT'
};
